<template>
  <div class="select-material">
    <div class="select-header">
        已上传素材
        <el-tooltip  effect="dark"  placement="top-start">
            <div slot="content" style="overflow-y: auto;max-height: 500px">
                <p>上传素材数需要为模板素材数的整倍数，并且图片与视频素材数量的倍数需要一致！</p>
                <p>当前模板素材数：图片{{ aiLaunchGlobal.tempPlatDdata.image_num }}，视频{{ aiLaunchGlobal.tempPlatDdata.video_num }}；</p>
                <p>
                    图片倍数：
                    <span class="text-color-error" v-if="!targetAppCountData.selectImgData.isInt">不满足整倍数</span>
                    <template v-else>  {{ targetAppCountData.selectImgData.multiple }}；</template>
                  
                </p>
                <p>
                    视频倍数：
                    <span class="text-color-error" v-if="!targetAppCountData.selectVideoData.isInt">不满足整倍数</span>
                    <template v-else>  {{ targetAppCountData.selectVideoData.multiple }}；</template>
                  
                </p>
                <p>
                    视频封面：
                    <template v-if="!targetAppCountData.noCoverIndexs.length">不缺失</template>
                    
                    <span v-else class="text-color-error">缺失（序号：{{targetAppCountData.noCoverIndexs.join('、')}}）</span>
                </p>
            </div>
            <div class="select-header-state">
                <i class="el-icon-warning-outline select-header-icon"/>
                <span class="text-color-success" v-if="targetAppCountData.isSuccess">满足搭建</span>
                <span class="text-color-error" v-else>不满足搭建</span>
            </div>
        </el-tooltip>
        <div class="del-all"><el-button type="text" @click="handleDelAll">清空</el-button></div>
    </div>
    <div class="select-list">
        <div class="select-list-imgs">
            <el-table 
              :data="displayImgList" 
              row-key="id" 
              :header-cell-style="{background:'#e8eaec',color:'#333'}" 
              max-height="780"
              v-el-table-infinite-scroll="loadMoreImg"
              :infinite-scroll-disabled="imgLoading"
              :infinite-scroll-distance="10"
              :infinite-scroll-immediate="false">
                <el-table-column label="序号" prop="index" width="80px" align="center">
                    <template slot-scope="{ $index }">
                        {{ selectImgList.length - $index }}
                    </template>
                </el-table-column>
                <el-table-column label="图片" align="center" prop="2">
                    <template slot-scope="{ row }">
                        <MaterialItem
                            :key="row.id"
                            v-if="row['2']"
                            :file="row['2']"
                            :type="row['2'].config.material_type == 3?'video':'image'"
                            @remove="()=>aiLaunchGlobal.handleSelectData(false, row['2'])"
                            isAimedia
                        />
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <!-- 不需要视频时不展示 -->
        <div class="select-list-videos" v-if="aiLaunchGlobal.tempPlatDdata.video_num !== 0">
            <!-- <div class="auto-generate"><el-button type="primary" plain size="mini">自动生成</el-button></div> -->
            <el-table 
              :data="displayVideoList" 
              row-key="id" 
              :header-cell-style="{background:'#e8eaec',color:'#333'}" 
              max-height="780"
              v-el-table-infinite-scroll="loadMoreVideo"
              :infinite-scroll-disabled="videoLoading"
              :infinite-scroll-distance="10"
              :infinite-scroll-immediate="false">
                <el-table-column label="序号" prop="index" align="center" width="80px">
                    <template slot-scope="{ $index }">
                        {{ selectVideoList.length - $index }}
                    </template>
                </el-table-column>
                <el-table-column label="视频" align="center" prop="3">
                    <template slot-scope="{ row }">
                        <MaterialItem
                            :key="row.id"
                            v-if="row['3']"
                            :file="row['3']"
                            :type="row['3'].config.material_type == 3?'video':'image'"
                            @remove="()=>aiLaunchGlobal.handleSelectData(false, row['3'])"
                            isAimedia
                        />
                    </template>
                </el-table-column>
                <el-table-column label="封面" align="center" prop="1">
                    <template slot="header">
                        封面
                        <el-button
                            size="mini"
                            type="primary"
                            plain
                            @click="handleAutoGenerate"
                            :disabled="genLoading"
                        >
                            {{ genLoading? '生成中...' : '自动生成' }}
                        </el-button>
                    </template>
                    <template slot-scope="{ row }">
                        <MaterialItem
                            :key="row.id"
                            v-if="row['1']"
                            :file="row['1']"
                            :type="row['1'].config.material_type == 3?'video':'image'"
                            @remove="()=>aiLaunchGlobal.handleSelectData(false, row['1'])"
                            isAimedia
                        />
                    </template>
                </el-table-column>
            </el-table>
        </div>
    </div>
  </div>
</template>

<script>
import MaterialItem from '../../materialItem.vue'
import { FILE_TYPE } from '../constant'
import _ from 'lodash'
import API from '@/api/marketManage/vivoBatch';
import ElTableInfiniteScroll from "el-table-infinite-scroll";
export default {
    inject: [ 'aiLaunchGlobal' ],
    components: { MaterialItem },
    directives: {
        "el-table-infinite-scroll": ElTableInfiniteScroll,
    },
    data() {
        return {
            genLoading: false,
            imgLoading: false,
            videoLoading: false,
            displayImgList: [],
            displayVideoList: [],
            pageSize: 20,
            currentImgPage: 1,
            currentVideoPage: 1
        }
    },
    computed: {
        targetAppData() {
            return this.aiLaunchGlobal.selectList[this.aiLaunchGlobal.appId] || { imgList: [], videoList: [] }
        },
        targetAppCountData() {
            return (
                this.aiLaunchGlobal.appMaterialDataResult[this.aiLaunchGlobal.appId] ||
                {
                    isSuccess: false, 
                    noCoverIndexs:[], 
                    selectVideoData: {multiple: 0,
                        isInt: false}, 
                        selectImgData: {multiple: 0,
                            isInt: false},
                    platNum: '-',
                }
            );
        },
        selectImgList() {
            return [ ...this.targetAppData.imgList ].reverse()
        },
        selectVideoList() {
            return [ ...this.targetAppData.videoList ].reverse()
        },
    },
    methods: {
        // 加载更多图片数据
        loadMoreImg() {
            if (this.imgLoading) return;
            this.imgLoading = true;
            
            const start = (this.currentImgPage - 1) * this.pageSize;
            const end = start + this.pageSize;
            const newData = this.selectImgList.slice(start, end);
            
            if (newData.length > 0) {
                this.displayImgList = [...this.displayImgList, ...newData];
                this.currentImgPage++;
            }
            
            this.imgLoading = false;
        },
        
        // 加载更多视频数据
        loadMoreVideo() {
            if (this.videoLoading) return;
            this.videoLoading = true;
            
            const start = (this.currentVideoPage - 1) * this.pageSize;
            const end = start + this.pageSize;
            const newData = this.selectVideoList.slice(start, end);
            
            if (newData.length > 0) {
                this.displayVideoList = [...this.displayVideoList, ...newData];
                this.currentVideoPage++;
            }
            
            this.videoLoading = false;
        },
        
        // 重置数据
        resetData() {
            this.displayImgList = [];
            this.displayVideoList = [];
            this.currentImgPage = 1;
            this.currentVideoPage = 1;
            this.loadMoreImg();
            this.loadMoreVideo();
        },
        
        handleDelAll() {
            if (!(this.selectImgList.length || this.selectVideoList.length)) {
                this.$message.error('当前没有选中的素材，请添加')
                return
            }
            this.$confirm('将删除所有已选择的素材，是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.aiLaunchGlobal.delAllCurAppData();
                this.resetData();
            }).catch(() => {});
        },
        async handleAutoGenerate() {
            this.genLoading = true
            const { videoList } = this.targetAppData;
            const { autoList = [], generateList =[], autoErrList =[] } = _.groupBy(videoList, (item)=> {
                const data = item[FILE_TYPE.COVER];
                if (data) {
                    return ''
                }else {
                    const videoData = item[FILE_TYPE.VIEDO] || {};
                    if (videoData.img_material_url) {
                        if ((videoData.img_material_size / 1024) >=100) {
                            return 'autoErrList'
                        }else {
                            return 'autoList'
                        }
                    }else {
                        return 'generateList'
                    }
                }
            });
            if (!(autoList.length || generateList.length || autoErrList.length)) {
                this.$message.error('没有需要生成的素材');
                this.genLoading = false
                return
            }
            if (autoErrList.length) {
                const indexMap = autoErrList.map(v=> {
                    return videoList.indexOf(v)
                });
                this.$notify.error({
                    title: '提示',
                    duration: 0,
                    dangerouslyUseHTMLString: true,
                    message: `<p>以下视频的封面自动生成后超出大小限制（100K），请手动截取上传</p>序号: ${indexMap.join(',')}`
                });
            };
            const fileConfigList = this.aiLaunchGlobal.fileConfigList
            const coverList = autoList.map(data=> {
                const { config, app_id, img_full_material_url,  height, width, img_material_url } = data[FILE_TYPE.VIEDO];
                const materialConfig = _.find(fileConfigList, { type: FILE_TYPE.COVER, conf_resolution: config.conf_resolution  })
                return {
                    id: data.id,
                    app_id,
                    config: materialConfig,
                    height,
                    width,
                    full_material_url:img_full_material_url,
                    img_full_material_url,
                    img_material_url,
                    material_url: img_material_url,
                    material_type: +materialConfig.type,
                    material_name: img_material_url.slice(img_material_url.lastIndexOf('/') +1)
                }
            });
            this.aiLaunchGlobal.handleSelectData(true, coverList)
            const generateData = await Promise.all(generateList.map(v=> {
                const data =  v[FILE_TYPE.VIEDO];
                const video_url = data.material_url || data.filePath;
                const params = {
                    video_url,
                    plat_id: '3',//固定传
                }
                return API.genVideoCoverImg(params).then(res=> {
                    return Object.assign(res, {
                        id: v.id,
                        config: data.config,
                        app_id: data.app_id
                    })
                }).catch(error=> {
                    console.log(error);
                    this.$message.error(error.info)
                    return null
                })
            }));
            const newGenerateData = _.difference(generateData, [null])
            const pushGenData = newGenerateData.map(v=> {
                const id = v.id, data = v.data, config = v.config, app_id = v.app_id;
                const materialConfig = _.find(fileConfigList, { type: FILE_TYPE.COVER, conf_resolution: config.conf_resolution  })
                return {
                    id,
                    config: materialConfig,
                    app_id,
                    ...data,
                    img_full_material_url: data.fullFilePath,
                    material_name: data.basename,
                    material_url: data.filePath,
                }
            });
            this.aiLaunchGlobal.handleSelectData(true, pushGenData);
             this.genLoading = false;
        },
        
    },
    watch: {
        selectImgList: {
            handler(newVal) {
                this.resetData();
            },
            deep: true
        },
        selectVideoList: {
            handler(newVal) {
                this.resetData();
            },
            deep: true
        }
    }
}
</script>

<style lang="scss" scoped>

.select-material {
    height: 850px;
    border-left: 1px solid #E4E7ED;
    &::v-deep {
        .el-table__header {
            height: 45px;
        }
    }
}
.select {
    &-header {
        height: 40px;
        display: flex;
        align-items: center;
        padding-left: 10px;
        width: 100%;
        &-state {
            cursor: pointer;
        }
        &-icon {
            font-size: 18px;
            margin: 0 6px;
            vertical-align: -2px;
        }
        .del-all {
           margin-left: auto;
           margin-right: 20px;
        } 
    }
    &-list {
        display: flex;
        height: calc(100% - 40px);
        &-imgs {
            flex: 1.2;
            width: 0;
            border-right: 1px solid #E4E7ED;
        }
        &-videos {
            flex: 2;
            width: 0;
            position: relative;
            .auto-generate {
                position: absolute;
                right: 10px;
                top: 6px;
                z-index: 9;
            }
        }
    }
}
</style>